import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/takeUntil';
import 'rxjs/add/observable/throw';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private cancelPending$ = new Subject<void>();
  private logoutInProgress = false;
  private readonly tokenErrorMessages = [
    "token_expired",
    "token has expired",
    "jwt expired",
    "invalid token",
    "unauthenticated",
  ];

  constructor(public router: Router,private cookieService: CookieService) {
    // console.log('interceptor hereeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee');
   }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // console.info('req.headers =', req.headers, ';');
    let token = window.localStorage.getItem('token') || '';
    const setHeaders: { [name: string]: string } = {
      'Authorization': 'Bearer ' + token
    };

    // Only JSON requests get a Content-Type. A multipart upload must be left
    // alone so the browser can set its own boundary - forcing
    // application/json here makes every FormData POST unparseable by the
    // server, which is why the ID-document upload needs this guard.
    if (!(req.body instanceof FormData)) {
      setHeaders['Content-Type'] = 'application/json';
    }

    req = req.clone({ setHeaders })
    return next.handle(req)
      .takeUntil(this.cancelPending$)
      .map((event: HttpEvent<any>) => {
        // console.log('interceoting rquest');
        //  console.log(event);
        if (event instanceof HttpResponse && event.status == 401) {
          // test response with valid version instead of error
        }
      
        return event;
      })
      .catch((err: any, caught) => {
        console.log(err);
        if (err instanceof HttpErrorResponse) {
          const errorMessage =
            err.error && err.error.message ? err.error.message : '';
          const normalizedErrorMessage = (errorMessage || "")
            .toString()
            .trim()
            .toLowerCase();
          if (err.status === 401) {
            this.handleUnauthorized();
          }
          if (
            err.status !== 400 &&
            this.tokenErrorMessages.includes(normalizedErrorMessage)
          ) {
            this.handleUnauthorized();
            // console.info('err.error =', err.error, ';');
          }
          return Observable.throw(err);
        }
        return Observable.throw(err);
      });
  }

  private handleUnauthorized(): void {
    if (this.logoutInProgress) {
      return;
    }
    this.logoutInProgress = true;
    this.cancelPending$.next();
    this.saveLastUrl();
    window.localStorage.clear();
    this.router.navigate(['login']).then(() => {
      this.logoutInProgress = false;
    });
  }

  private saveLastUrl(): void {
    const currentUrl = this.router.url;
    if (!currentUrl || currentUrl.startsWith('/login')) {
      return;
    }
    sessionStorage.setItem('last_url', currentUrl);
  }
}



// WEBPACK FOOTER //
// ./src/app/guards/auth-interceptor.ts